export default function Footer() {
  return (
    <footer className="bg-purple-900 text-white relative overflow-hidden">
      {/* Textura de fondo */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-16">
        {/* Área superior */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-12 pb-12 border-b border-white/20">
          <div className="mb-6 md:mb-0">
            <img
              src="https://static.readdy.ai/image/89057b92bf34c08c001dd5517bca6a4e/219dca12fd8acd291afc5e7ef7253dd5.png"
              alt="PatyPublicidad Logo"
              className="h-16 w-auto brightness-0 invert"
            />
          </div>
          <div className="text-2xl md:text-3xl font-script text-pink-300 italic">
            Estrategia, creatividad y conexión para tu marca
          </div>
        </div>

        {/* Área de navegación */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Columna 1 - Servicios */}
          <div>
            <h3 className="font-bold text-lg mb-4">Servicios</h3>
            <ul className="space-y-2">
              <li>
                <a href="#servicios" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer text-sm">
                  Gestión de redes
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer text-sm">
                  Creación de contenido
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer text-sm">
                  Estrategia digital
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer text-sm">
                  Diseño gráfico
                </a>
              </li>
            </ul>
          </div>

          {/* Columna 2 - Recursos */}
          <div>
            <h3 className="font-bold text-lg mb-4">Recursos</h3>
            <ul className="space-y-2">
              <li>
                <a href="#portafolio" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer text-sm">
                  Portafolio
                </a>
              </li>
              <li>
                <a href="#testimonios" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer text-sm">
                  Testimonios
                </a>
              </li>
              <li>
                <a href="#sobre-mi" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer text-sm">
                  Sobre mí
                </a>
              </li>
              <li>
                <a href="#contacto" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer text-sm">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Columna 3 - Legal */}
          <div>
            <h3 className="font-bold text-lg mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer text-sm">
                  Privacidad
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer text-sm">
                  Términos
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer text-sm">
                  Cookies
                </a>
              </li>
            </ul>
          </div>

          {/* Columna 4 - Redes sociales */}
          <div>
            <h3 className="font-bold text-lg mb-4">Sígueme</h3>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/patypublicidad"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-pink-500 transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://facebook.com/patypublicidad"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-pink-500 transition-all cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a
                href="https://tiktok.com/@patypublicidad"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-pink-500 transition-all cursor-pointer"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line text-xl"></i>
              </a>
              <a
                href="https://linkedin.com/in/patypublicidad"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-pink-500 transition-all cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Área inferior */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-300">
            <div className="font-serif">
              © 2025 PatyPublicidad. Todos los derechos reservados.
            </div>
            <div>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink-300 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
